/**
 * Converts period name to startDate endDate values pair according to current timezone
 *
 * @category Transport
 */
export function getDatesFromPeriod(params) {
  if (!params) {
    return
  }
  const periodName = params.period
  if (!periodName) {
    params.period = null
  } else {
    let startDate = new Date()
    let endDate = new Date()
    switch (periodName) {
      case '3hrs':
        endDate.setHours(startDate.getHours() + 3)
        break
      case '6hrs':
        endDate.setHours(startDate.getHours() + 6)
        break
      case '9hrs':
        endDate.setHours(startDate.getHours() + 9)
        break
      case 'live':
      case '24hrs':
        endDate.setDate(startDate.getDate() + 1)
        break
      case 'today':
        endDate.setDate(startDate.getDate() + 1)
        endDate.setHours(0, 0, 0, 0)
        break
      case 'tomorrow':
        startDate.setDate(startDate.getDate() + 1)
        startDate.setHours(0, 0, 0, 0)

        endDate.setDate(endDate.getDate() + 2)
        endDate.setHours(0, 0, 0, 0)
        break
      case 'week':
        endDate.setDate(startDate.getDate() + 8)
        endDate.setHours(0, 0, 0, -1)
        break
      case 'all':
        endDate.setDate(startDate.getDate() + 30)
        break
      default:
        startDate = new Date(Date.parse(periodName))
        startDate.setHours(0, 0, 0, 0)
        endDate = new Date(Date.parse(periodName))
        endDate.setHours(23, 59, 59, 999)
    }
    params.startDate = startDate.toISOString()
    params.endDate = endDate.toISOString()
    params.period = 'period' + periodName
  }
}
